import { Modal, ModalCloseButton, PromoNewsletter } from '@presentation/components';
import type { FC } from 'react';
import newsletterDog from './assets/postman.webp';
import * as Styled from './styled';
import type { NewsletterModalProps } from './types';

export const NewsletterModal: FC<NewsletterModalProps> = (props) => {
  const { modal, newsletter } = props;

  return (
    <Modal {...modal}>
      <Styled.Wrapper>
        <ModalCloseButton modal={modal} />
        <Styled.ImageWrapper>
          <img src={newsletterDog} alt="newsletterdog" />
        </Styled.ImageWrapper>
        <Styled.FromWrapper>
          <PromoNewsletter {...newsletter} />
        </Styled.FromWrapper>
      </Styled.Wrapper>
    </Modal>
  );
};
